// One root registration retains privacy migration and defers ordinary updates
// while entered information is present. Nothing is saved to device storage.
export function registerPrivacyServiceWorker(win = window) {
  const serviceWorker = win.navigator.serviceWorker;
  if (!serviceWorker) return;
  let refreshing = false, dirty = Boolean(win.__lightlyHasEnteredInformation), waiting;
  const wasControlled = Boolean(serviceWorker.controller);
  win.document?.addEventListener('input', () => { dirty = true; }, {capture: true});
  win.document?.addEventListener('change', () => { dirty = true; }, {capture: true});
  const announce = () => {
    if (!win.document || win.document.getElementById('lightly-update-ready')) return;
    const notice=win.document.createElement('aside');notice.id='lightly-update-ready';notice.setAttribute('role','status');
    notice.style.cssText='position:fixed;bottom:80px;right:16px;z-index:2000;padding:16px;background:#fff;border:1px solid #cbd5e1;border-radius:16px;color:#17243b;box-shadow:0 8px 30px #0002;max-width:320px;font:14px system-ui';
    const text=win.document.createElement('p');text.textContent='An update is ready. Finish and save your work before reloading.';
    const button=win.document.createElement('button');button.type='button';button.textContent='Reload when ready';
    button.onclick=()=>{dirty=false;if(waiting)waiting.postMessage({type:'SKIP_WAITING',safeToReload:true});else win.location.reload();};
    notice.append(text,button);win.document.body.appendChild(notice);
  };
  serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing || !wasControlled) return;
    if (dirty) {waiting=null;announce();return;}
    refreshing=true;win.location.reload();
  });
  const activate = worker => {waiting=worker;if(dirty)announce();else worker.postMessage({type:'SKIP_WAITING',safeToReload:true});};
  return serviceWorker.register('/service-worker.js',{updateViaCache:'none'}).then(registration=>{
    registration.update?.().catch(()=>{});
    if(registration.waiting)activate(registration.waiting);
    registration.addEventListener('updatefound',()=>{const worker=registration.installing;worker?.addEventListener('statechange',()=>{if(worker.state==='installed'&&serviceWorker.controller)activate(worker);});});
    return registration;
  }).catch(error=>console.warn('Lightly service worker registration failed:',error));
}
